import React, { useEffect } from 'react';
import styles from "page/css/Account.module.css";
import { Chip, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { accountActions } from "reducers/account";
import AccountService from "service/apiConfig/AccountService";

const AccountForm = ({ create, input, setInput }) => {
    const dispatch = useDispatch();
    const roles = useSelector(state => state.accountData.roles);
    const accountDetail = useSelector(state => state.accountData.accountDetail);
    const { role, username, name, password, passwordConfirm } = accountDetail;

    useEffect(() => {
        AccountService.getRoles()
            .then(response => {
                dispatch(accountActions.setRoles(response.data.data));
            })
            .catch(err => console.log(err));
    }, [dispatch])

    const onChangeInput = (e) => {
        const { name, value } = e.target;
        if (create) {
            setInput({
                ...input,
                [name]: value
            })
        } else {
            dispatch(accountActions.setAccountDetail({
                ...accountDetail,
                [name]: value
            }));
        }
    }
    return (
        <form className={`accountForm ${styles.accountForm}`}>
            <dl className={styles.accountRole}>
                <dt>
                    <Chip label="계정 권한" sx={{ marginRight: "0.5rem" }} />
                </dt>
                <FormControl size="small" sx={{ minWidth: "200px" }}>
                    <InputLabel id="demo-simple-select-label">권한</InputLabel>
                    <Select
                        label={"role"}
                        onChange={onChangeInput}
                        name={"role"}
                        value={create ? input.role || '' : role.id ? role.id : role || ''}
                    >
                        {roles.map((role, index) => (
                            <MenuItem key={role.id} value={role.id}>{role.name} / {role.category}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </dl>
            <dl>
                <dt><Chip label="아이디" sx={{ marginRight: "0.5rem" }} /></dt>
                <dd>
                    <TextField
                        className={`textInput ${styles.textInput}`}
                        defaultValue={!create ? username || '' : input.username || ''}
                        onChange={onChangeInput}
                        label={"아이디"}
                        name={"username"}
                        variant="outlined"
                        size={"small"}
                        disabled={!create}
                    />
                </dd>
            </dl>
            <dl>
                <dt><Chip label="사용자 이름" sx={{ marginRight: "0.5rem" }} /></dt>
                <dd>
                    <TextField
                        className={`textInput ${styles.textInput}`}
                        defaultValue={!create ? name || '' : input.name || ''}
                        onChange={onChangeInput}
                        label={"이름"}
                        name={"name"}
                        variant="outlined"
                        size={"small"}
                    />
                </dd>
            </dl>
            <dl>
                <dt><Chip label={create ? '비밀번호' : '비밀번호 수정'} sx={{ marginRight: "0.5rem" }} /></dt>
                <dd>
                    <TextField
                        className={`textInput ${styles.textInput}`}
                        defaultValue={!create ? password || '' : input.password || ''}
                        onChange={onChangeInput}
                        type={"password"}
                        label={create ? '비밀번호' : '비밀번호 수정'}
                        name={"password"}
                        variant="outlined"
                        size={"small"}
                    />
                </dd>
            </dl>
            <dl>
                <dt><Chip label="비밀번호 확인" sx={{ marginRight: "0.5rem" }} /></dt>
                <dd>
                    <TextField
                        className={`textInput ${styles.textInput}`}
                        defaultValue={!create ? passwordConfirm || '' : input.passwordConfirm || ''}
                        onChange={onChangeInput}
                        type={"password"}
                        label={"비밀번호 확인"}
                        name={"passwordConfirm"}
                        variant="outlined"
                        size={"small"}
                        error={!create && passwordConfirm !== "" ? passwordConfirm !== password : input.passwordConfirm !== input.password}
                        helperText={!create && passwordConfirm !== "" ? passwordConfirm !== password ? "비밀번호가 일치하지 않습니다." : "" : input.passwordConfirm !== input.password ? "비밀번호가 일치하지 않습니다." : "" }
                    />
                </dd>
            </dl>
        </form>
    );
};

export default AccountForm;